export function getFileExtension(fileName: string): string {
  if (fileName) {
    const index = fileName.lastIndexOf(".");
    if (index !== -1) {
      return fileName.substring(index + 1).toLowerCase();
    }
  }

  return "";
}

export function undefinedReplacer(_key: string, value: any): any {
  return value === undefined ? null : value;
}

/**
 * Stringifies an Error object.
 */
export function stringifyError(error: Error): string {
  if (!error) {
    return "";
  }

  const errorProperties = Object.getOwnPropertyNames(error);
  const inheritedProperties = Object.getOwnPropertyNames(
    Object.getPrototypeOf(error)
  );
  return JSON.stringify(error, [...errorProperties, ...inheritedProperties]);
}
